<template>
  <div class="margin-bottom-4xl">
    <div class="row align-stretch">
      <div
        v-for="feature in features"
        :key="feature.id"
        :class="featureClass"
      >
        <component
          :is="feature.location.href ? 'a' : 'site-link'"
          v-bind="getLocationProps(feature)"
          :class="setFeatureCardClass(feature.theme)"
          style="gap: var(--spacing-lg); --card-link-box-shadow-color: var(--card-link-hover-border-color); height: 100%"
          @click="handleFeatureClick(feature)"
        >
          <font-awesome-icon
            :icon="$v6[feature.icon.style][feature.icon.name]"
            fixed-width
            size="2x"
            class="margin-right-3xs"
          />
          <div>
            <h3
              class="h6 margin-bottom-sm text-uppercase"
              style="letter-spacing: var(--letter-spacing-2xl)"
            >
              {{ feature.title }}
            </h3>
            <p class="size-sm">{{ feature.description }}</p>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
  import { featureLinksMixin } from '../mixins'

  export default {
    name: 'IconsFeaturesLongTerm',

    mixins: [featureLinksMixin],

    props: {
      features: {
        type: Array,
        required: true
      }
    },

    computed: {
      featureClass() {
        return `column-12 margin-bottom-lg laptop:margin-bottom-0 laptop:column`
      }
    },

    methods: {
      setFeatureCardClass(theme) {
        return `card header roomy margin-0 text-left display-flex flex-row flex-items-start ${theme}`
      }
    }
  }
</script>
